<div class="card mat-elevation-z2" (click)="goToLink()">
    <div class="thumbnail" [style.background-image]="imageUrl"></div>
    <div class="title">{{ cardData.label }}</div>
    <mat-icon class="icon">arrow_forward_ios</mat-icon>
</div>